import { Button } from 'antd';
import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { getAllSetting } from '../../service/base';
import { CONST_SITE } from '../../utils/common/const';

const navItems = [
  { name: 'Trang chủ', href: 'https://www.78winl.xyz/' },
  { name: 'Dự đoán', href: '/' },
  { name: 'Thể lệ', href: '/rule' },
  { name: 'Kết quả', href: '/prize-structure' }
];

const Header = () => {
  // const location = useLocation();
  // const activeNav = location.pathname;
  const [settings, setSettings] = useState({
    link_login: '#',
    link_register: '#',
    link_home: '#'
  });
  const mounted = useRef(false);
  // const [isModalHistory, setIsModalHistory] = useState(false);
  const [IP, setIP] = useState('');
  const [FP, setFP] = useState('');

  useEffect(() => {
    mounted.current = true;

    const fetchData = async () => {
      try {
        const res = await getAllSetting({
          site: CONST_SITE.OK9
        });
        if (mounted.current) {
          const settingsMap = {};
          res.data.forEach((item) => {
            settingsMap[item.key] = item.content || '#';
          });
          setSettings(settingsMap);
          // Update the home link in navItems
          navItems[0].href = settingsMap.link_home || '#';
        }
      } catch (error) {
        console.error('Error fetching settings:', error);
      }
    };

    fetchData();

    return () => {
      mounted.current = false;
    };
  }, []);

  return (
    <div className="w-full">
      <div
        className="w-full max-w-[1280px] mx-auto rounded-b-[25px]
            flex flex-row items-center justify-between
            py-1 md:py-3
            px-2 md:px-3 lg:px-6"
      >
        <Link to={settings.link_home || '#'}>
          <img
            src="/assets/images/header/header_clutch.png"
            alt="Linh vat 78Win"
            className="hidden md:flex w-[80%] object-contain"
          />
        </Link>
        <div className="flex flex-col py-3 items-center justify-center md:mx-0 md:mr-20 mx-auto">
          <Link className="flex items-center justify-center" to={settings.link_home || '#'}>
            <img
              src="/assets/images/header/logo.png"
              alt="Logo 78Win"
              className="md:w-[36%] w-[50%] h-auto object-contain"
            />
          </Link>
          <h5 className="mt-3 md:mt-5 text-xl sm:text-2xl lg:text-3xl font-bold text-primary">
            DỰ ĐOÁN KẾT QUẢ BÓNG ĐÁ
          </h5>
          <img
            src="/assets/images/header/linhvat_mb.png"
            alt="Linh vat 78Win"
            className="flex md:hidden w-[80%] mt-3 h-auto object-contain"
          />
          <div className="flex flex-row md:hidden mt-8 gap-2 md:py-4">
            <Button
              // type="primary"
              className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-black"
              onClick={() => window.open(settings.link_home, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'black',
                color: 'white'
              }}
            >
              TRANG CHỦ
            </Button>
            <Button
              // type="primary"
              className="text-white text-xs sm:text-sm px-8 py-1 font-medium rounded-[8px] border-0 bg-black"
              onClick={() => window.open(settings.link_register, '_blank', 'noopener,noreferrer')}
              style={{
                background: 'black',
                color: 'white'
              }}
            >
              ĐĂNG KÝ
            </Button>
          </div>
        </div>

        <div className="hidden md:flex flex-col mt-8 gap-2 md:py-4">
          <Button
            type="primary"
            className="text-white text-xs md:text-sm px-8 py-1 font-medium rounded-[8px] border-0"
            onClick={() => window.open(settings.link_home, '_blank', 'noopener,noreferrer')}
            style={{
              background: 'linear-gradient(180deg, #53ADFF 0%, #0066FF 100%)'
            }}
          >
            TRANG CHỦ
          </Button>
          <Button
            type="primary"
            className="text-white text-xs md:text-sm px-8 py-1 font-medium rounded-[8px] border-0"
            onClick={() => window.open(settings.link_register, '_blank', 'noopener,noreferrer')}
            style={{
              background: 'linear-gradient(180deg, #53ADFF 0%, #0066FF 100%)'
            }}
          >
            ĐĂNG KÝ
          </Button>
        </div>
      </div>
      {/* <HistoryPredictions
        isModalVote={isModalHistory}
        setIsModalVote={setIsModalHistory}
        IP={IP}
        FP={FP}
      /> */}
    </div>
  );
};

export default Header;
